import { Pipe, PipeTransform } from '@angular/core';
import LinkifyIt from 'linkify-it';

@Pipe({
  name: 'linkify',
  standalone: false,
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    const matches = LinkifyIt().match(value);

    matches?.forEach(({ text, url }) => {
      value = value.replace(text, `<a href="${url}">${text}</a>`);
    });

    return value;
  }
}
